export default __webpack_public_path__ + "static/media/icon-ob-templates.14342e00.svg";